import React from "react";

const SkeletonCard = () => (
  <div className="animate-pulse bg-white rounded-2xl shadow border border-gray-100 p-4 flex flex-col gap-3 mb-3">
    <div className="h-4 w-1/3 bg-gray-200 rounded mb-2" />
    <div className="flex gap-2 items-center">
      <div className="h-8 w-8 bg-gray-200 rounded-full" />
      <div className="h-4 w-1/2 bg-gray-200 rounded" />
    </div>
    <div className="h-3 w-1/4 bg-gray-200 rounded" />
    <div className="h-3 w-1/5 bg-gray-200 rounded" />
    <div className="h-8 w-20 bg-gray-200 rounded mt-2" />
  </div>
);

export default SkeletonCard; 